import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { StatusIndicatorType } from './status-indicator.type';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'trp-status-indicator',
  standalone: true,
  imports: [TranslateModule, FontAwesomeModule],
  templateUrl: './status-indicator.component.html',
  styleUrls: ['./status-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusIndicatorComponent {
  @Input({ required: true })
  @HostBinding('class')
  type: StatusIndicatorType = 'none';
}
